import { Image } from 'expo-image';
import { StyleSheet, TouchableOpacity, View } from 'react-native';

import { formatCurrency } from '@/utils/currencyFormat';
import { formatDayTime } from '@/utils/dateFormats';
import { firebaseImage, safeJsonParseArray, ThumbSize } from '@/utils/firebaseImage';
import { i18n } from '@/utils/i18n';

import FavoriteButton from '../buttons/FavoriteButton';
import Text from '../Text';

interface ImpactItemListProps {
  npoId: string;
  impactImage: string;
  impactTitle: string;
  impactAmount: number;
  impactDate: string;
  onCardPress: () => void;
}

const ImpactItemList = ({
  npoId,
  impactImage,
  impactTitle,
  impactAmount,
  impactDate,
  onCardPress
}: ImpactItemListProps) => {
  //Locales
  const donate = i18n.t('donation.donate');

  return (
    <TouchableOpacity style={styles.touchable} onPress={onCardPress}>
      <View style={styles.container}>
        <Image
          source={firebaseImage(safeJsonParseArray(impactImage ?? '[]')?.at(0) ?? '', ThumbSize.Small)}
          style={styles.image}
        />
        <View style={styles.dataContainer}>
          <View style={styles.horizontalContainer}>
            <Text style={styles.title} fontWeight="900" ellipsizeMode="tail" numberOfLines={1}>
              {impactTitle}
            </Text>
            <FavoriteButton itemId={npoId} type={'npo'} />
          </View>
          <Text style={styles.title} fontWeight="500">
            {formatCurrency(impactAmount)}
          </Text>
          <View style={[styles.horizontalContainer, styles.btnContainer]}>
            <Text style={styles.date} fontWeight="500" ellipsizeMode="tail" numberOfLines={1}>
              {formatDayTime(impactDate)}
            </Text>
            <TouchableOpacity style={styles.actionBtn} onPress={onCardPress}>
              <Text style={styles.actionBtnText} fontWeight="700">
                {donate}
              </Text>
            </TouchableOpacity>
          </View>
        </View>
      </View>
    </TouchableOpacity>
  );
};

const styles = StyleSheet.create({
  touchable: {
    paddingVertical: 25
  },

  container: {
    flexDirection: 'row'
  },

  image: {
    height: 90,
    width: 90,
    borderRadius: 10
  },

  title: {
    flex: 1,
    flexWrap: 'wrap',
    fontSize: 18,
    color: 'black',
    marginRight: 20
  },

  amount: {
    fontSize: 16
  },

  date: {
    fontSize: 15,
    opacity: 0.6,
    flex: 1,
    flexWrap: 'wrap',
    marginRight: 10
  },

  dataContainer: {
    flex: 1,
    paddingLeft: 10,
    borderRadius: 5,
    color: 'black',
    justifyContent: 'space-between'
  },

  actionBtn: {
    borderRadius: 20,
    borderColor: 'black',
    borderWidth: 1,
    paddingHorizontal: 25,
    paddingVertical: 9
  },

  actionBtnText: {
    fontSize: 14,
    color: 'black'
  },

  horizontalContainer: {
    flexDirection: 'row',
    justifyContent: 'space-between'
  },

  btnContainer: {
    alignItems: 'flex-end'
  }
});

export default ImpactItemList;
